




import { Component } from 'vue-property-decorator';

import { OnboardingURL } from '@/views/Onboarding/helpers';

import YourAccountComplete from '../default-user-signup/YourAccountComplete.vue';
import BusinessOnboardingModel from '@/views/BusinessOnboarding/BusinessOnboardingModel.vue';

@Component({
  components: { YourAccountComplete }
})
export default class AIYourAccountComplete extends BusinessOnboardingModel {
  hasFinishTracking = false;

  get backUrl() {
    return OnboardingURL.AI_USER_SIGN_UP;
  }

  async onNext() {
    await this.onCreateAICampaigns();
    await this.redirectAIFlow();
  }
}
